// src/components/SplashScreen.js
import React, { useEffect, useState } from 'react';
import { useGoogleMaps } from './GoogleMapsProvider';
import './SplashScreen.css';

const SplashScreen = () => {
  const [progress, setProgress] = useState(0);
  const [loadingText, setLoadingText] = useState('جاري تحميل التطبيق...');
  const { isLoaded } = useGoogleMaps();

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 5; // Slower progression
      });
    }, 150);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const loadingTexts = [
      'جاري تحميل التطبيق...',
      'جاري إعداد الخرائط...',
      'جاري تجهيز البيانات...',
      'جاري الاتصال بالخادم...',
      'أهلاً بك في التطبيق!'
    ];

    const textInterval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * loadingTexts.length);
      setLoadingText(loadingTexts[randomIndex]);
    }, 1500);

    return () => clearInterval(textInterval);
  }, []);

  useEffect(() => {
    if (!isLoaded) {
      setLoadingText('جاري تحميل الخريطة...');
    }
  }, [isLoaded]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <div className="splash-logo-container">
          <img src="/logo.png" alt="AtDelivery Logo" className="splash-logo pulse" />
        </div>
        <div className="progress-bar">
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>
        <p className="splash-text">{loadingText}</p>
      </div>
    </div>
  );
};

export default SplashScreen;